import React from 'react';
import styled from 'styled-components/macro';

import { EntityType } from '../../../../types.generated';
import { EmptyTab } from '../../shared/components/styled/EmptyTab';
import { RelationshipItem, GlossaryRelatedEntity } from '../../shared/types';
import RelatedTerm from './RelatedTerm';

export type Props = {
    loading?: boolean;
    glossaryRelatedTermType: string;
    glossaryRelatedTermResult: RelationshipItem[];
    canRemoveRelatedTerms?: boolean;
    canRemoveRelatedNodes?: boolean;
    removeDisabledTooltip?: string;
};

const ListContainer = styled.div`
    width: 100%;
`;

export default function GlossaryRelatedTermsResult({
    loading,
    glossaryRelatedTermType,
    glossaryRelatedTermResult,
    canRemoveRelatedTerms = true,
    canRemoveRelatedNodes = true,
    removeDisabledTooltip,
}: Props) {
    const glossaryRelatedTerms: GlossaryRelatedEntity[] = glossaryRelatedTermResult.map((item) => ({
        urn: item.entity?.urn || '',
        type: item.entity?.type || '',
        isInverse: item.isInverse,
        relationshipType: item.relationshipType,
        customRelationTypeUrn: item.customRelationTypeUrn || '',
        previewData: item.entity,
    }));

    const getEntityType = (entityType: string) => {
        if (!entityType) {
            return EntityType.GlossaryTerm;
        }
        return entityType === EntityType.GlossaryTerm ? EntityType.GlossaryTerm : EntityType.GlossaryNode;
    };

    const getCanRemove = (entityType: EntityType) =>
        entityType === EntityType.GlossaryTerm ? canRemoveRelatedTerms : canRemoveRelatedNodes;

    return (
        <ListContainer>
            {glossaryRelatedTerms.map((entity) => (
                <RelatedTerm
                    urn={entity?.urn}
                    isLoading={loading}
                    isInverse={entity?.isInverse}
                    entityType={getEntityType(entity?.type)}
                    key={`${entity?.urn}-${entity?.relationshipType}`}
                    customRelationTypeUrn={entity?.customRelationTypeUrn || ''}
                    relationshipType={entity?.relationshipType}
                    canRemove={getCanRemove(getEntityType(entity?.type))}
                    removeDisabledTooltip={removeDisabledTooltip}
                    previewData={entity?.previewData}
                />
            ))}
            {glossaryRelatedTerms?.length === 0 && <EmptyTab tab={glossaryRelatedTermType?.toLocaleLowerCase()} />}
        </ListContainer>
    );
}
